import { ReactNode, useCallback, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Tooltip } from 'antd';
import { BiMenu, BiMenuAltLeft } from 'react-icons/bi';

import { useAuth } from '../../hooks/auth';
import Switch from '../../components/SwitchTheme';

import { Button, Container, Divider } from './styles';

interface HeaderMenuProps {
  children?: ReactNode;
}

export const HeaderMenu = ({ children }: HeaderMenuProps) => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const { pathname } = useLocation();

  useEffect(() => {
    setSelected(pathname.substring(1, pathname.length));

    return setSelected(pathname.substring(1, pathname.length));
  }, [pathname]);

  const handleToggleMenu = useCallback(
    (evt) => {
      evt.stopPropagation();
      setIsOpen(!isOpen);
    },
    [isOpen, setIsOpen]
  );

  return (
    <Container isMenuOpen={isOpen} onClick={handleToggleMenu}>
      {children}
      {!isOpen ? <BiMenu /> : <BiMenuAltLeft />}
      <div className="menu">
        <h1>portal de jogos a recreativa</h1>
        {user ? (
          <>
            <Link to="/">
              <Button active={selected === ''}>
                <p>Início</p>
              </Button>
            </Link>
            <Link to="/tournaments">
              <Button active={selected === 'tournaments'}>
                <p>Torneios</p>
              </Button>
            </Link>
            <Link
              to="/leagues"
              onClick={(event) => event.preventDefault()}
              className="disabled-link"
            >
              <Tooltip placement="right" title="Em breve...">
                <Button active={selected === 'leagues'}>
                  <p>Ligas</p>
                </Button>
              </Tooltip>
            </Link>
            <Divider />
            <Link to="/jogo/cacapalavras/709">
              <Button active={selected === 'jogo/cacapalavras'}>
                <p>Caça palavras</p>
              </Button>
            </Link>
            <Link to="/jogo/palavrascruzadas/560">
              <Button active={selected === 'jogo/palavrascruzadas'}>
                <p>Palavras Cruzadas</p>
              </Button>
            </Link>
            <Link to="/jogo/sudoku/470">
              <Button active={selected === 'jogo/sudoku'}>
                <p>Sudoku</p>
              </Button>
            </Link>
            <Link to="/jogo/rebus/778">
              <Button active={selected === 'jogo/rebus'}>
                <p>Rébus</p>
              </Button>
            </Link>
            <Link
              to="/jogo/wordle"
              onClick={(event) => event.preventDefault()}
              className="disabled-link"
            >
              <Tooltip placement="right" title="Em breve...">
                <Button active={selected === 'jogo/wordle'}>
                  <p>Wordle</p>
                </Button>
              </Tooltip>
            </Link>
            <Divider />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Switch />
            </div>
          </>
        ) : (
          <>
            <Link to="/">
              <Button active={selected === ''}>
                <p>login</p>
              </Button>
            </Link>
            <Link to="/cadastrar">
              <Button active={selected === 'cadastrar'}>
                <p>Cadastrar</p>
              </Button>
            </Link>
            <Link to="/recuperar-senha">
              <Button active={selected === 'recuperar-senha'}>
                <p>Recuperar Senha</p>
              </Button>
            </Link>
            <Divider />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Switch />
            </div>
          </>
        )}
      </div>
    </Container>
  );
};
